module.exports = __webpack_public_path__ + "static/media/bz.ca77ff97.svg";